import React from "react";
import PropTypes from "prop-types";
import { formatCurrency } from "../../../../lib/utils";

const CurrencyCell = ({ value, align = "text-right" }) => (
  <td className={align}>{formatCurrency(value)}</td>
);

CurrencyCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  align: PropTypes.string
};

CurrencyCell.defaultProps = {
  align: "text-right"
};

export default CurrencyCell;



// WEBPACK FOOTER //
// ./src/components/applicationsComponents/applicationsCommon/cells/CurrencyCell.jsx